import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core'
import { provideRouter, withInMemoryScrolling } from '@angular/router'

import { routes } from './app.routes'
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { providePrimeNG } from 'primeng/config'
import { provideHttpClient, withFetch } from '@angular/common/http'
import radiusAutoPreset from './assets/theme/primeNgTheme'

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withInMemoryScrolling({
				scrollPositionRestoration: 'enabled',
			}),
		),
		provideClientHydration(withIncrementalHydration()),
		provideHttpClient(withFetch()),
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: radiusAutoPreset,
				options: {
					darkModeSelector: '.my-app-dark',
				},
			},
		}),
	],
}
